import styled from 'styled-components';
import rmq from 'styled-rmq';

export default styled.div`
	display: table;
	width: 100%;
	margin: 0 auto;
	position: relative;

	${rmq('720')} {
		padding-top: 4rem;
	}
	${rmq('ms')} {
		padding: 0;
	}

	&::before {
		content: '';
		z-index: -1;
		position: absolute;
		top: 0px;
		left: 0px;
		width: 100%;
		height: 80vh;
		height: 90vh;
		/* height: 1100vh; */
		min-height: 64rem;
		transform-origin: 0px center 0px;
		transform: skewY(-12deg);
		background: linear-gradient(57deg, ${props => props.theme.c2} 0%, ${props => props.theme.c1} 100%);

		${rmq('xl')} {
			height: 90vh;
		}
		${rmq('ll')} {
			height: 115vh;
		}
		${rmq('ls')} {
			height: 100vh;
		}
		${rmq('ml')} {
			transform: skewY(0deg);
		}
	}
`;
